import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ModalCalculateComponent } from 'src/app/modules/report-management/modal-calculate/modal-calculate.component';

@Component({
  selector: 'lifedi-report-profile-matching-template',
  templateUrl: './report-profile-matching-template.component.html',
  styleUrls: ['./report-profile-matching-template.component.scss']
})
export class ReportProfileMatchingTemplateComponent implements OnInit {
  @Input() reportForm: FormGroup;
  @Input() reportType: string;
  @Input() reportID: string;
  @Input() measureID: string;
  @Input() isEdit: boolean;
  @Input() isPaid: boolean;

  constructor(
    private fb: FormBuilder,
    public matDialog: MatDialog
  ) { }

  ngOnInit(): void {
    if (this.reportForm.value.PSY_BLOCKS.length === 0 && this.reportForm.value.IDEAL_DATA.length === 0) {
      this.addGroup();
      this.addIdeal();
    }
  }

  openCalculateModal(form, i, isEdit) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      reportId: this.reportID,
      measureId: this.measureID,
      isEdit: isEdit,
      title: 'คำนวณ',
      calData: form.value.CAL,
      typeReport: this.reportType,
      actionBtnText: 'บันทึก',
    }

    const modal = this.matDialog.open(ModalCalculateComponent, dialogConfig);
    modal.afterClosed().pipe(
      map(res => {
        if (res.status) {
          form.get('CAL').patchValue(res.data);
          form.get('CAL').updateValueAndValidity();
        }
      }),
      catchError((err) => {
        // console.log(err);
        alert(err.error.message)
        return of(null);
      }),
    ).subscribe();
  }

  addGroup() {
    this.psyBlocksArr.push(this.fb.group({
      PSY_BLOCKS_ID: [`BK${new Date().getTime()}`, Validators.required],
      PSY_NAME: ['', Validators.required],
      COLOR_CODE: ['', Validators.required],
      DETAIL_PSY: ['', Validators.required],
      CAL: [null, Validators.required]
    }))
    this.addSubIdeal();
  }

  addIdeal() {
    this.idealDataArr.push(this.fb.group({
      IDEAL_NAME: ['', Validators.required],
      IDEALS: this.fb.array([])
    }))

    this.reportForm.value.PSY_BLOCKS.map((res, i) => {
      // // console.log(res);
      this.idealDataArr['controls'][this.idealDataArr.length - 1].get('IDEALS')['controls'].push(this.fb.group({
        PSY_NAME: [this.psyBlocksArr.value[i].PSY_NAME, Validators.required],
        PSY_BLOCKS_ID: [this.psyBlocksArr.value[i].PSY_BLOCKS_ID, Validators.required],
        POINT: ['', Validators.required]
      }))
    })
    // console.log(this.reportForm.value);
  }

  addSubIdeal() {
    this.reportForm.value.IDEAL_DATA.map((ideals, i) => {
      this.idealDataArr['controls'][i].get('IDEALS')['controls'].push(this.fb.group({
        PSY_NAME: [this.psyBlocksArr.value[this.psyBlocksArr.length - 1].PSY_NAME, Validators.required],
        PSY_BLOCKS_ID: [this.psyBlocksArr.value[this.psyBlocksArr.length - 1].PSY_BLOCKS_ID, Validators.required],
        POINT: ['', Validators.required]
      }))
    })
  }

  updatePoint(form, e, i) {
    form.get('IDEALS').at(i).patchValue({
      POINT: e.target.valueAsNumber
    })
    form.get('IDEALS').updateValueAndValidity();
  }

  updatePsyName(form) {
    this.reportForm.value.IDEAL_DATA.map((ideal, i) => {
      ideal.IDEALS.map((res, j) => {
        if (form.value.PSY_BLOCKS_ID === res.PSY_BLOCKS_ID) {
          // update ค่ากรณีที่ผู้ใช้เลือกชื่อด้านใน ideal ก่อน แล้วเปลี่ยนชื่อลักษณะทางจิตวิทยา
          (<FormArray>this.idealDataArr['controls'][i].get('IDEALS')).at(j).patchValue({
            PSY_NAME: form.value.PSY_NAME
          });
          // setValue เพื่อให้ค่าที่อยู่ใน option เปลี่ยนเป็นค่าล่าสุด
          (<FormArray>this.idealDataArr['controls'][i].get('IDEALS')).at(j).setValue({
            PSY_NAME: form.value.PSY_NAME,
            PSY_BLOCKS_ID: form.value.PSY_BLOCKS_ID,
            POINT: res.POINT
          });
          this.idealDataArr['controls'][i].get('IDEALS').updateValueAndValidity();
        }
      });
    });
  }

  removePsyBlocks(i) {
    this.psyBlocksArr.removeAt(i);
    this.reportForm.value.IDEAL_DATA.map((res, j) => {
      (<FormArray>this.idealDataArr['controls'][j].get('IDEALS')).removeAt(i);
    })
  }

  removeIdealBlocks(i) {
    this.idealDataArr.removeAt(i);
  }

  get psyBlocksArr(): FormArray {
    return this.reportForm.get('PSY_BLOCKS') as FormArray;
  }

  get idealDataArr(): FormArray {
    return this.reportForm.get('IDEAL_DATA') as FormArray;
  }
}
